import React from 'react';
import { useMessageGetter } from 'react-message-context';
import { Dropdown, DropdownProps } from '../../../components/common/Dropdown';
import { ContractTerminationReason } from './schema';

const terminationReasons = [
  ContractTerminationReason.AREA_POOR_SERVICES,
  ContractTerminationReason.HOUSING_COSTS,
  ContractTerminationReason.POOR_APARTMENT_CONDITION,
  ContractTerminationReason.APARTMENT_SIZE,
  ContractTerminationReason.DISTURBING_NEIGHBOURS_OR_BUILDING,
  ContractTerminationReason.MOVE_TO_RIGHT_OF_OCCUPANCY,
  ContractTerminationReason.MOVE_TO_CARE_HOME_OR_HOSPITAL,
  ContractTerminationReason.MOVE_TO_ANOTHER_APARTMENT_OF_SAME_OWNER,
  ContractTerminationReason.MOVE_DUE_WORK,
  ContractTerminationReason.MOVE_TO_ANOTHER_MUNICIPALITY,
  ContractTerminationReason.BUYING_PROPERTY,
  ContractTerminationReason.FAMILY_SIZE_CHANGE,
];

export const TerminationReasonDropdown = ({ onChange, value, id, width, hasError }: Omit<DropdownProps, 'options'>) => {
  const t = useMessageGetter('forms.terminateLease');

  const options = terminationReasons
    .map((reason) => {
      const label = t(reason);
      return { label: label, value: reason };
    })
    .sort((a, b) => a.label.localeCompare(b.label));

  return <Dropdown onChange={onChange} value={value} id={id} options={options} width={width} hasError={hasError} />;
};
